import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import './styles/resize.less';
var supportResizeObserver = ResizeObserver.toString().includes('[native code]');

function resetTrigger(triggers) {
  var expand = triggers.firstElementChild;
  var contract = triggers.lastElementChild;
  var expandChild = expand.firstElementChild;
  contract.scrollLeft = contract.scrollWidth;
  contract.scrollTop = contract.scrollHeight;
  expandChild.style.width = "".concat(expand.offsetWidth + 1, "px'");
  expandChild.style.height = "".concat(expand.offsetHeight + 1, "px");
  expand.scrollLeft = expand.scrollWidth;
  expand.scrollTop = expand.scrollHeight;
}

var Resize = /*#__PURE__*/function (_PureComponent) {
  _inherits(Resize, _PureComponent);

  var _super = _createSuper(Resize);

  function Resize(props) {
    var _this;

    _classCallCheck(this, Resize);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "refNode", void 0);

    _defineProperty(_assertThisInitialized(_this), "_resizeObserver", void 0);

    _defineProperty(_assertThisInitialized(_this), "rootRef", void 0);

    _defineProperty(_assertThisInitialized(_this), "_resizeNode", void 0);

    _defineProperty(_assertThisInitialized(_this), "refExpand", void 0);

    _defineProperty(_assertThisInitialized(_this), "refShrink", void 0);

    _this.rootRef = /*#__PURE__*/React.createRef();
    _this.state = {
      domWidth: 0,
      domHeight: 0
    };
    return _this;
  }

  _createClass(Resize, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (supportResizeObserver) {
        this._resizeNode = this.rootRef.current;

        if (!this._resizeNode) {
          return;
        }

        if (!this.props.enableSizeNotifyDeferred) {
          this._notifyResize(this._resizeNode);
        }

        this._resizeObserver = new ResizeObserver(entries => {
          entries.forEach(entry => {
            var {
              target,
              contentRect
            } = entry; // 修复某些case下target不在DOM中， 触发的width/height都为0

            if (!target.parentElement) {
              return;
            }

            if (this.props.enableResizeObserverContentRect) {
              // 使用 round 以保证与 offsetWidth 等取整值相同
              this._onResize({
                width: Math.round(contentRect.width),
                height: Math.round(contentRect.height)
              });
            } else {
              this._onResize({
                width: target.offsetWidth,
                height: target.offsetHeight
              });
            }
          });
        });

        this._resizeObserver.observe(this._resizeNode);
      } else {
        this._initSize();
      }
    }
  }, {
    key: "_notifyResize",
    value: function _notifyResize(resizeNode) {
      if (this.props.onResize) {
        // lazy getter
        var cachedWidth;
        var cachedHeight;
        var _rect = {
          get width() {
            if (cachedWidth === undefined) {
              cachedWidth = resizeNode.offsetWidth;
            }

            return cachedWidth;
          },

          get height() {
            if (cachedHeight === undefined) {
              cachedHeight = resizeNode.offsetHeight;
            }

            return cachedHeight;
          }

        };

        this._onResize(_rect);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._resizeObserver) {
        this._resizeObserver.unobserve(this._resizeNode);

        this._resizeObserver.disconnect();

        this._resizeObserver = null;
      }
    }
  }, {
    key: "_updateSize",
    value: function _updateSize(rect) {
      var domWidth = rect.width;
      var domHeight = rect.height;
      this.setState({
        domWidth: domWidth + 1,
        domHeight: domHeight + 1
      });
    }
  }, {
    key: "_onResize",
    value: function _onResize(rect) {
      if (this.props.onResize) {
        this.props.onResize(rect);
      }
    }
  }, {
    key: "_onExpand",
    value: function _onExpand() {
      var domRect = this._getRect();

      this._updateSize(domRect);

      if (this.props.onExpand) {
        this.props.onExpand(domRect);
      }

      this._onResize(domRect);

      resetTrigger(this.refNode);
    }
  }, {
    key: "_onShrink",
    value: function _onShrink() {
      var domRect = this._getRect();

      this._updateSize(domRect);

      if (this.props.onShrink) {
        this.props.onShrink(domRect);
      }

      this._onResize(domRect);

      resetTrigger(this.refNode);
    }
  }, {
    key: "_initSize",
    value: function _initSize() {
      var rect = this._getRect();

      this._updateSize(rect);

      this._onResize(rect);

      resetTrigger(this.refNode);
    }
  }, {
    key: "_getRect",
    value: function _getRect() {
      var dom = this.refNode;
      return dom.getBoundingClientRect();
    }
  }, {
    key: "renderPolyfillEl",
    value: function renderPolyfillEl() {
      var {
        domWidth,
        domHeight
      } = this.state;
      return /*#__PURE__*/React.createElement("div", {
        className: "resizeTrigger",
        ref: node => {
          this.refNode = node;
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "resize-expandTrigger",
        ref: node => {
          this.refExpand = node;
        },
        onScroll: this._onExpand.bind(this)
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          width: domWidth,
          height: domHeight
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "resize-contractTrigger",
        ref: node => {
          this.refShrink = node;
        },
        onScroll: this._onShrink.bind(this)
      }, /*#__PURE__*/React.createElement("div", {
        className: "resize-contractChild"
      })));
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        style: this.props.wrapperStyle,
        ref: this.rootRef
      }, this.props.children, !supportResizeObserver && this.renderPolyfillEl());
    }
  }]);

  return Resize;
}(PureComponent);

_defineProperty(Resize, "propTypes", {
  onExpand: PropTypes.func,
  onShrink: PropTypes.func,
  onResize: PropTypes.func,
  wrapperStyle: PropTypes.object
});

export default Resize;